import { useMemo } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import http from 'hub-http/clients/apiClient';
const COLLECTED_FORM_BASE_URL = 'collected-forms/v1/forms';
const LEAD_FLOWS_BASE_URL = 'lead-flows/v1/lead-flows';
const FORMS_BASE_URL = 'forms/v2/forms';
const HUBSPOT_FORMS_BASE_URL = 'hubspot-forms/v1/form';
export const DELETE_FORM_FIELD_NAME = 'deleteForm';
export const DELETE_FORM = registerMutation({
  fieldName: DELETE_FORM_FIELD_NAME,
  args: ['guid', 'formType', 'embedVersion'],
  fetcher({
    guid,
    formType,
    embedVersion
  }) {
    if (embedVersion === EmbedVersions.V4) {
      return http.delete(`${HUBSPOT_FORMS_BASE_URL}/${guid}`);
    }
    switch (formType) {
      case FormTypes.CAPTURED:
        return http.delete(`${COLLECTED_FORM_BASE_URL}/${guid}`);
      case FormTypes.FLOW:
        return http.delete(`${LEAD_FLOWS_BASE_URL}/${guid}`);
      default:
        return http.delete(`${FORMS_BASE_URL}/${guid}`);
    }
  }
});
export function useDeleteForm({
  guid,
  formType,
  embedVersion
}) {
  const [deleteForm, {
    error,
    loading
  }] = useMutation(DELETE_FORM, {
    variables: {
      guid,
      formType,
      embedVersion
    }
  });
  return useMemo(() => ({
    deleteForm,
    error,
    loading
  }), [deleteForm, error, loading]);
}